import "./ContactPage.css";
import CTA from "../../components/cta/cta";
import PageHeader from "../../components/pageheader/pageheader";
function ContactPage() {
  return (
    <>
      <PageHeader title="Contact" />

      <CTA whiteBackground />
    </>
  );
}

export default ContactPage;
